import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { OemConstants } from '../../core/routing/services/oem/constants/oem.constants';
import { GlobalConstants } from '../../common/constants/global.constant';
import { RouterConstants } from '../../core/routing/constants/app-paths.constant';
import { CreatePartnerContentComponent } from './create-partner-content/create-partner-content.component';
import { PartnersService } from 'src/app/core/routing/services/Partners_api/partners.service';
import { Subject } from 'rxjs/internal/Subject';
import { Utils } from '../../common/utils/utils';

@Component({
  selector: 'iposcen-oem-portal',
  templateUrl: './oem-portal.component.html',
  styleUrls: ['./oem-portal.component.scss']
})
export class OemPortalComponent implements OnInit {
  @ViewChild('forCreateEdit') forCreateEdit: CreatePartnerContentComponent;
  tabIndex: number;
  currentdetailPage: string;
  showView: boolean;
  showAttractorView: boolean;
  contentId: string;
  attractorLoopId: string;
  showPublishedMessage = false;
  autoID: string;
  editData: any;
  showHideNavBar: boolean;
  disableCreatePartner: string;
  disableAttractorLoop: string;
  loginUserRole = sessionStorage.getItem('userRole');
  modelSkuInfo: string = RouterConstants.MODEL_SKU_INFO_LINK;
  createPartner: string = RouterConstants.CREATE_PARTNER_CONTENT_LINK;
  attractorLoop: string = RouterConstants.ATTRACTOR_LOOP_LINK;
  title: string = OemConstants.title;
  myAccount: string = OemConstants.myAccount;
  notification: string = OemConstants.notification;
  logout: string = OemConstants.logout;
  modelSkuInfoTab: string = OemConstants.modelSkuInfoTab;
  createpartnerContentTab: string = OemConstants.createpartnerContentTab;
  attractorLoopTab: string = OemConstants.attractorLoopTab;
  showPartnerContent: boolean;
  isNewPartnerContent: boolean;
  attractorLoopToolTip = OemConstants.attractorLoopToolTip;
  contentGroupToolTip = OemConstants.contentGroupToolTip;
  isCreateNewAttrEnable = false;
  selectList;
  isCreateAttrInEditMode = false;
  adminRef = false;
  publishedOEMMsg: string;
  expiredOEMMsgTime: string;
  showOEMMessage: boolean = false;
  isOEMMsgExpired: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  constructor(private router: Router,
    private partnerservice: PartnersService) { }

  ngOnInit(): void {
    this.showView = false;
    this.showAttractorView = false;
    this.showPartnerContent = true;
    this.tabIndex = 0;
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === 'model-sku-info') {
      this.tabIndex = 0;
    } else if (this.currentdetailPage.substring(pageName + 1) === 'create-partner-content') {
      this.tabIndex = 1;
    } else if (this.currentdetailPage.substring(pageName + 1) === 'attractor-loop') {
      this.tabIndex = 2;
    }
    this.getOEMMessage();
  }

  getOEMMessage() {
    const checkPresentDate = new Date();
    this.partnerservice.getPreviousOEMMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        if (response.message.publishedMsg != undefined) {
          this.publishedOEMMsg = response.message.publishedMsg;
          this.expiredOEMMsgTime = response.message.ExpirationTime;
          if (this.publishedOEMMsg) {
            this.isOEMMsgExpired = (this.expiredOEMMsgTime !== GlobalConstants.NEVER) ? Utils.customDateCheck('Now', this.expiredOEMMsgTime) : false;
            this.showOEMMessage = !this.isOEMMsgExpired ? true : false;
            let updatedTime = new Date(this.expiredOEMMsgTime);
            if (updatedTime < checkPresentDate) {
              this.showPublishedMessage = true;
            }
          }
        }
      });
  }

  redirectToLogin() {
    sessionStorage.clear();
    location.assign(RouterConstants.SLASH);
  }

  redirectToHome() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  disableCreatePartners(data) {
    if (data === 'true') {
      this.disableCreatePartner = '';
      this.disableAttractorLoop = '';
    } else {
      this.disableCreatePartner = 'true';
      this.disableAttractorLoop = 'true';
    }
  }

  disableAttractorLoops(value) {
    setTimeout(() => {
      this.showPartnerContent = true;
      this.showView = false;
      this.showAttractorView = false;
    }, 0);

  }

  disableAttractLoop(data) {
    if (data === 'true') {
      this.disableAttractorLoop = '';
    } else {
      this.disableAttractorLoop = 'true';
    }
  }

  showTabs(data) {
    if (data === false) {
      this.showPartnerContent = false;
    } else {
      this.showPartnerContent = true;
    }
  }
  sendEditData(data) {
    this.tabIndex = 1;
    this.showPartnerContent = false;
    setTimeout(_ => {
      this.forCreateEdit.callOnEdit(data);
    }, 0);
  }
  createAttractLoopData(data) {
    this.isCreateNewAttrEnable = true
    this.selectList = data;
  }
}
